import React from 'react';
import YoutubePlayer from '../../common/YoutubePlayer';
import CloseModalButton from '../../common/Modal/Buttons/CloseModalButton';

export default function Modal(props) {
	return (
		<div className='project-popup '>
			<h1 className='project-popup__title '>Pizza ordering application</h1>
			<p className='project-popup__description '>
				React pizza application with a catchy user interface. This application is
				developed for devices of any screen width. It's fully responsive. The app's
				source code is available on my GitHub profile; please follow the "source
				code" link below.
			</p>
			<div className='project-popup__about '>
				<p>
					<span className='span-title '>Stack:</span>
					<span className='span-description '>
						<br /> Frontend: React.js, Redux, SCSS, Webpack, Responsive web <br />{' '}
						Backend: Node.js + Express, Mongo.db (Mongoose)
					</span>
				</p>
			</div>
			<div className='project-popup__videos'>
				<YoutubePlayer
					src='https://www.youtube.com/embed/LVoBu6X-ZXs'
					title='Pizza application (React.js + Node.js)'
				/>
			</div>
			<div className='project-popup__buttons'>
				<a
					href='https://github.com/Slava-Nik/Pizza-ordering-app'
					className='project-link '
					target='_blank'
					rel='noopener noreferrer'
				>
					Source code
				</a>
				<CloseModalButton onClose={props.closeModal} />
			</div>
		</div>
	);
}
